import React from "react";

type TasksInfoType = {}
const TasksInfo:React.FC<TasksInfoType> = () => {
    return <div>
        <p>Мои решения различных задач со ссылками на репозиторий и развертку на gitPages</p>
    </div>
}
export default TasksInfo
